export default __webpack_public_path__ + "assets/mobilepay-a57370db81f177d7a13706ad30fb759e.png";